<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import BuildingCreate from '../../../buildings/components/BuildingCreate.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        childNavItems: [
            {
                label: 'Business',
                route: '/(app)/settings/business/',
            },
            {
                label: 'Buildings',
                route: '/(app)/settings/buildings/',
            },
            {
                label: 'Skills',
                route: '/(app)/settings/skills/',
            },
            {
                label: 'Groups',
                route: '/(app)/settings/groups/',
            },
            {
                label: 'Shift Reasons',
                route: '/(app)/settings/shift-reasons/',
            },
        ],
    }
})
</script>

<template>
  <BuildingCreate />
</template>